// SUDO CODE:
// 1. Create a new announcement object on form submit /////
// 2. add ref to the navbar button
// 3. add ref to the form
/////////////////////////////////////////////////////////

import React, { useEffect, useState } from 'react'
import instance from '../../axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUserCategories, setUserSubcategories } from '../../redux/reducers/categoriesSlice';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

function AddAnnouncement() {

      const [inputTitle, setInputTitle] = useState("");
      const [quantity, setQuantity] = useState("");
      const [measurement, setMeasurement] = useState("");
      const [inputCategoryValue, setInputCategoryValue] = useState("");
      const [inputDescription, setInputDescription] = useState("");
      const [error, setError] = useState(false);
      const [success, setSuccess] = useState(false);
    
      const [categoryInputValue, setCategoryInputValue] = useState("");
      const [subCategoryInputValue, setSubCategoryInputValue] = useState("");
    
      const [isLoading, setIsLoading] = useState(false);
    
      const { currentUser } = useSelector((state) => state.user);
      const { categoriesArray, subCategoriesArr } = useSelector(
        (state) => state.categories
      );
    
      const dispatch = useDispatch();
    
      const mosqueId = currentUser?.data?.user?.mosque_admin?.mosque_id;
    
      const handleChange = (event) => {
        setCategoryInputValue(event.target.value);
      };
      const subHandleChange = (event) => {
        setSubCategoryInputValue(event.target.value);
      };
    
      useEffect(() => {
        instance.get(`api/categories`).then((res) => {
          dispatch(setUserCategories(res.data.data.categories));
          setIsLoading(false);
        });
      }, []);
    
      useEffect(() => {
        if (categoryInputValue) {
          instance.get(`api/categories/${categoryInputValue}`).then((res) => {
            dispatch(setUserSubcategories(res.data.data.category.children));
            setIsLoading(false);
          });
        }
      }, [categoryInputValue]);
    
      const emptyInputValues = (input) => {
        setInputTitle("");
        setQuantity("");
        setMeasurement("");
        setInputCategoryValue("");
        setInputDescription("");
      };
    
      const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        const announcement = {
          // mosque_id: mosqueId,
          mosque_id: 2,
          name: inputTitle,
          amount: quantity,
          amount_type: measurement,
          category_id: categoryInputValue,
          text: inputDescription,
        };
    
        if (
          announcement.mosque_id &&
          announcement.name &&
          announcement.amount &&
          announcement.amount_type &&
          announcement.category_id &&
          announcement.text
        ) {
          setIsLoading(true);
    
          instance
            .post(`api/ads`, announcement, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              emptyInputValues();
              setSuccess(true);
              setIsLoading(false);
            })
            .catch((e) => {
              setIsLoading(false);
              setError(true);
            });
        }
      };


  return (
      <div className="container mx-auto p-2">
      <div className="relative pt-2">
        <div className="max-w-2xl mx-auto">
          <form className="admin-form" onSubmit={handleFormSubmit}>
            <div className="relative z-0 mb-6 w-full group">
              <input
                type="text"
                name="title"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
                autoComplete="off"
                onChange={(e) => setInputTitle(e.target.value)}
                value={inputTitle}
              />
              <label
                // for="title"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                Nomi
              </label>
            </div>
            <div className="relative z-0 mb-6 w-full group">
              <input
                type="number"
                name="floating_password"
                id="floating_password"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
                onChange={(e) => setQuantity(e.target.value)}
                value={quantity}
              />
              <label
                // for="floating_password"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                Miqdori
              </label>
            </div>

            <div className="grid xl:grid-cols-2 xl:gap-6">
              <div className="relative z-0 mb-4 w-full group">
                <h2 className="mb-2">O'lchov birligi</h2>
                <div className="relative inline-flex">
                  <svg
                    className="w-2 h-2 absolute top-0 right-0 m-4 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232">
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#648299"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    className="border border-gray-300 rounded-full cursor-pointer text-gray-600 h-10 pl-5 pr-10 bg-white hover:border-gray-400 focus:outline-none appearance-none"
                    onChange={(e) => setMeasurement(e.target.value)}
                    value={measurement}>
                    <option value={"kg"}>Kg</option>
                    <option value={"tonna"}>Tonna</option>
                    <option value={"dona"}>Dona</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="flex justify-between">
              <div className="mb-5">
                <Box sx={{ minWidth: 166 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Kategoriya
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={categoryInputValue}
                      label="Kategoriya"
                      onChange={handleChange}>
                      {categoriesArray.length > 0 ? (
                        categoriesArray?.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem>Kategoriya yo'q</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div className="mb-5">
                <Box sx={{ minWidth: 166 }}>
                  <FormControl
                    fullWidth
                    disabled={
                      !categoryInputValue || subCategoriesArr.length === 0
                    }>
                    <InputLabel id="demo-simple-select-label">
                      Kategoriya
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={subCategoryInputValue}
                      label="Kategoriya"
                      onChange={subHandleChange}>
                      {subCategoriesArr.length > 0 ? (
                        subCategoriesArr?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>Kategoriya yo'q</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>

            <div className="max-w-2xl mx-auto mb-10">
              <textarea
                id="message"
                rows="4"
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Qo’shimcha malumotlar..."
                onChange={(e) => setInputDescription(e.target.value)}
                value={inputDescription}></textarea>
            </div>
            <button
              type="submit"
              className="text-white block bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              Tasdiqlash
            </button>
          </form>
        </div>
      </div>

      {isLoading ? (
        <h1 className="mt-4 font-bold">Yuklanmoqda...</h1>
      ) : error ? (
        <h1 className="mt-4 text-red-600 font-bold">
          Xatolik yuz berdi. Qayta urinib ko'ring!
        </h1>
      ) : success ? (
        <h1 className="mt-4 text-green-600 font-bold">
          E'lon muvaffaqiyatli yuklandi!
        </h1>
      ) : (
        ""
      )}
    </div>
  )
}

export default AddAnnouncement